import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { merge, Stack } from '@fluentui/react';
/**
 * This is a layout container for pages that have the "full page" layout
 * where the page fills the entire viewport but limits the width of the content
 * to a max width of 1600px and is centered in the viewport.
 */
export const FullPage1600pxLayoutStack = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    return _jsx(Stack, Object.assign({}, makeProps(otherProps), { children: children }));
};
const makeProps = (props) => merge({}, {
    horizontalAlign: 'stretch',
    styles: {
        root: {
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    tokens: { padding: '3% 1em', childrenGap: '2em', maxWidth: '1600px' },
}, props || {});
